const clearRichTextField = (e) => {
  const clearButton = document.querySelector('#clear-rich-text-field');
  if(clearButton) clearButton.addEventListener('click', () => {
    const editor = document.querySelector('trix-editor');
    if(editor) editor.innerHTML = '';
  })
}

document.addEventListener('turbo:load', clearRichTextField);
